module.exports = __webpack_public_path__ + "img/huibao.1cfa8997.png";